<template>
  <form @submit.prevent="handleSubmit" class="d--f fd--c pa-20px">
    <AppInput
      v-model="inputMessage"
      type="textarea"
      :autosize="{ minRows: 1, maxRows: 10 }"
      placeholder="Ask a question about your report..."
      class="mb-10px"
      :disabled="disabled"
      @keydown.enter.prevent="handleEnterKey"
    />

    <AppButton type="submit" variant="primary" :disabled="!inputMessage.trim() || disabled">
      {{ disabled ? "Sending..." : "Send" }}
    </AppButton>
  </form>
</template>

<script setup>
import { ref } from "vue";
import { AppButton, AppInput } from "@/components/ui";

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(["send-message"]);

const inputMessage = ref("");

const handleSubmit = () => {
  if (!inputMessage.value.trim() || props.disabled) return;

  emit("send-message", inputMessage.value);
  inputMessage.value = "";
};

const handleEnterKey = (event) => {
  if (!event.shiftKey) {
    handleSubmit();
  }
};
</script>
